import { colors } from "@/utils/const";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CustomText from "../text";

export default function SectionTitle({ title, description, note }) {
  return (
    <Box sx={{ bgcolor: colors.navy, overflowX: "hidden" }}>
      <Box
        component="section"
        className="horizontal-safe-padding vertical-safe-padding"
        sx={{ overflow: "hidden" }}
      >
        <Grid
          container
          spacing={{ xs: 1, md: 2 }}
          sx={{
            flexDirection: {
              xs: "column",
              md: "row",
            },

            alignItems: {
              xs: "start",
              md: "center",
            },
          }}
        >
          <Grid item xs={12} md={4}>
            <CustomText
              text={title}
              type="xl"
              customStyle={{ color: colors.dark_yellow, fontWeight: "700" }}
              variant="h2"
            />
          </Grid>

          <Grid item xs={12} md={8}>
            {description && (
              <CustomText
                text={description}
                type="xs"
                customStyle={{
                  color: colors.white,
                  lineHeight: "24px",
                  fontWeight: "300",
                  whiteSpace: "pre-line",
                }}
                variant="body1"
                enableHtml="true"
              />
            )}

            {note && (
              <CustomText
                text={note}
                type="xxs"
                customStyle={{
                  color: colors.white,
                  lineHeight: "24px",
                  mt: { xs: 2, md: 4 },
                  fontWeight: "300",
                  whiteSpace: "pre-line",
                }}
                variant="body1"
                enableHtml="true"
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
